import React, { useCallback, useEffect, useRef, useState } from "react"
import { Box, Container, Flex, Text, Grid } from "@theme-ui/components"
import ArticleThumb from "./articleThumb"
import { useResponsiveValue, useBreakpointIndex } from "@theme-ui/match-media"
import SwiperCore, { Pagination, Navigation, Mousewheel, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"
import { i18nContext } from "../context/i18nContext"
import ArrowLink from "./arrowLink"
import ArrowBlack from "../images/Arrow_black.inline.svg"
SwiperCore.use([Navigation, Mousewheel, A11y])
// End swiper

const LatestArticles = ({ articles }) => {
  const mediaIndex = useBreakpointIndex()

  const sliderRef = useRef(null)
  const [activeIndex, setActiveIndex] = useState(1)

  const [prevEl, setPrevEl] = useState(null)
  const [nextEl, setNextEl] = useState(null)

  return (
    <i18nContext.Consumer>
      {t => (
        <Box sx={{ ".swiper-wrapper": { alignItems: "stretch" } }}>
          <Container>
            <Flex
              sx={{
                justifyContent: "space-between",
                pt: [4, 6, 8],
                pb: [4, 6, 5],
              }}
            >
              <Text
                as="h2"
                variant="h2"
                mb={5}
                sx={{
                  color: "dark",
                  mt: [2, 3, 3, 5],
                  mb: [0, 0, 0, 0],
                  textTransform: "uppercase",
                }}
              >
                {t.latestFairs}
              </Text>
              {mediaIndex > 1 && (
                <ArrowLink
                  theme={"light"}
                  item={{
                    anchor: t.readAllFairs,
                    locale: t.locale,
                    link: {
                      anchor: t.readAllFairs,
                      locale: t.locale,
                      _allSlugLocales: articles[0].category._allSlugLocales,
                      model: {
                        apiKey: "article_category",
                      },
                    },
                  }}
                  sx={{
                    maxWidth: ["350px", "350px", "350px", "650px"],
                    width: "100%",
                    mt: [0, 0, 0, 0],
                  }}
                />
              )}
            </Flex>
            <Grid
              columns={[
                "1fr",
                "1fr",
                "minmax(150px,160px) auto",
                "minmax(150px,160px) auto",
              ]}
              gap={[0, 6, 8, 10]}
            >
              <Box
                sx={{
                  mb: [5, 5, 5, 0],
                  width: "100%",
                  maxWidth: ["250px", "350px"],
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Flex
                  sx={{
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      mr: [2],
                      cursor: "pointer",
                      svg: {
                        stroke: "dark",
                      },
                      "&:hover,&:focus": {
                        svg: {
                          stroke: "primary",
                        },
                      },
                    }}
                    ref={node => setPrevEl(node)}
                  >
                    <ArrowBlack />
                  </Box>
                  <Box
                    sx={{
                      ml: [2],
                      cursor: "pointer",
                      svg: {
                        transform: "rotate(180deg)",
                        stroke: "dark",
                      },
                      "&:hover,&:focus": {
                        svg: {
                          stroke: "primary",
                        },
                      },
                    }}
                    ref={node => setNextEl(node)}
                  >
                    <ArrowBlack />
                  </Box>
                </Flex>
              </Box>
              <Box
                sx={{
                  ".swiper-slide": {
                    width: ["100%", "350px!important"],
                    height: "auto",
                  },
                }}
              >
                <Swiper
                  draggable={true}
                  mousewheel={{
                    forceToAxis: true,
                  }}
                  navigation={{ prevEl, nextEl }}
                  ref={sliderRef}
                  spaceBetween={16}
                  slidesPerView={"auto"}
                  onActiveIndexChange={swiper => {
                    setActiveIndex(swiper.activeIndex + 1)
                  }}
                  onInit={swiper => {}}
                  onChange={swiper => {}}
                >
                  {articles.map((article, index) => (
                    <SwiperSlide key={article.id}>
                      <ArticleThumb article={article} index={index} small />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            </Grid>
            {mediaIndex < 2 && (
              <Box sx={{ pt: [5, 6, 7] }}>
                <ArrowLink
                  theme={"light"}
                  item={{
                    anchor: t.readAllFairs,
                    locale: t.locale,
                    link: {
                      anchor: t.readAllFairs,
                      locale: t.locale,
                      _allSlugLocales: articles[0].category._allSlugLocales,
                      model: {
                        apiKey: "article_category",
                      },
                    },
                  }}
                  sx={{
                    maxWidth: ["350px", "350px", "350px", "650px"],
                    width: "100%",
                    mt: [0, 0, 0, 0],
                  }}
                />
              </Box>
            )}
          </Container>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

export default LatestArticles
